export default "__VITE_ASSET__BKwZO0Mw__"